import React from 'react';
import {AdvancedMarker} from '@vis.gl/react-google-maps';
import styles from './Mapping.module.css';

const MyFieldsMarker = ({farmField}) => {

  return (
    <>
      <AdvancedMarker
        position={{
          lng: farmField.Longitude,
          lat: farmField.Latitude
        }}
        key={farmField.FieldId}>
        <div className={styles.farmScoreboard}>
          <div className={styles.farmScoreboardName}>{farmField.FieldId}</div>
          <div className={styles.farmScoreboardBr}></div>
          <div className={styles.farmScoreboardDataDiv}>
            <div>{Number(farmField.Acres).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})}</div>
            <div>Acres</div>
          </div>
          <div className={styles.farmScoreboardDataDiv}>
            <div>{farmField.Commodity !== undefined ? farmField.Commodity : 'N/A'}</div>
          </div>
          <div className={styles.farmScoreboardDataDiv}>
            <div>{farmField.TotalNetUnits !== undefined ? farmField.TotalNetUnits.toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,}) : 'N/A'}</div>
            <div>{'Bushels for Year'}</div>
          </div>
          <div className={styles.farmScoreboardDataDiv}>
            <div>
              {
                isNaN(farmField.Yield) ?
                  'N/A' :
                  Number(farmField.Yield).toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
            </div>
            <div>{'Yield for Year'}</div>
          </div>
          <div className={styles.farmScoreboardDataDiv}>
            <div>
              {
                farmField.WeightedAverage === undefined ? 
                  'N/A' :
                  farmField.WeightedAverage.toLocaleString('en-US', {style: 'decimal', maximumFractionDigits: 2, minimumFractionDigits: 2,})
              }
              </div>
            <div>{'Weighted Avg'}</div>
            <div>{'(5 mile radius)'}</div>
          </div>
          <div className={styles.farmScoreboardArrow}></div>
        </div>
      </AdvancedMarker>
    </>
  );
};

export default MyFieldsMarker;